// extracted by mini-css-extract-plugin
module.exports = {"social-share-links":"_1a6rt","messanger-hide":"drWbn"};